/* rb-cookie v1 ----------------------------------------------------------------
   ROBBYTOYS: Das Skript hinter der Einwilligungsabfrage. Angelegt 15.09.2026.

   WAS ES TUT, in der Reihenfolge, in der es passiert:
     1. Es liest die gespeicherte Entscheidung. Gibt es keine, zeigt es den
        Kasten. Gibt es eine, meldet es sie stillschweigend weiter und zeigt
        nichts.
     2. Jede Entscheidung wird mit Zeitpunkt und Fassung der Gruppen abgelegt
        (Nachweispflicht) und an die Einwilligungs-Schnittstelle des
        Ladensystems weitergereicht. Ein Kasten, der nur ein Fenster
        schliesst, waere eine Luege.
     3. Vor der Entscheidung ist ausser den notwendigen Cookies nichts an und
        nichts vorangekreuzt. Weiterklicken, Scrollen und Danebenklicken
        gelten NICHT als Zustimmung; es gibt deshalb auch kein
        Schliessen-Kreuz. Escape wirkt wie "Nur notwendige" -- aber NUR,
        solange noch keine Entscheidung vorliegt. Liegt eine vor, schliesst
        Escape bloss das Fenster und schreibt nichts (16.09.2026).
     4. Eine Entscheidung haelt LAUFZEIT_TAGE Tage. Danach gilt sie als
        nicht vorhanden und es wird erneut gefragt.

   ⚠️ DIE DREI ZUSTAENDE, die ein Wert haben kann:
        true   ausdruecklich erlaubt
        false  ausdruecklich abgelehnt
        nichts noch nicht gefragt -- und dann laeuft nichts.

   Der Speicher ist der Browser des Besuchers (localStorage). Er kann in
   einem privaten Fenster oder bei gesperrten Website-Daten fehlen oder
   werfen; jeder Zugriff steht deshalb in einem try. Faellt der Speicher aus,
   erscheint der Kasten bei jedem Aufruf wieder -- lieber einmal zu oft
   gefragt als einmal ungefragt gemessen.
----------------------------------------------------------------------------- */
(function () {
  'use strict';

  var SCHLUESSEL = 'rb-einwilligung';
  /* Die Fassung der Gruppen. Wer eine Gruppe hinzufuegt oder ihren Sinn
     aendert, zaehlt hoch: dann wird jede aeltere Entscheidung ungueltig und
     erneut gefragt. Genau dafuer steht die Zahl in der Ablage. */
  var FASSUNG = 1;
  /* ⚠️ 16.09.2026 NACHGETRAGEN: DIE EINWILLIGUNG LAEUFT AB.
     Gemessen am 16.09.2026: ein 13,5 Monate alter Eintrag wurde
     anstandslos uebernommen, der Kasten blieb weg. Eine Einwilligung ohne
     Ende ist keine Einwilligung mehr, sondern ein Freibrief -- niemand
     erinnert sich nach einem Jahr, wem er was erlaubt hat.
     ⚠️ DIE ZAHL GEHOERT DEN INHABERN, NICHT DIESER DATEI. 365 ist hier nur
     der uebliche deutsche Massstab: die Aufsichtsbehoerden nennen
     regelmaessig ein Jahr. Beschlossen ist sie nicht. Wer sie aendert,
     aendert sie hier UND traegt sie in die Datenschutzerklaerung nach --
     eine Frist, die nur im Skript steht, kann der Besucher nicht lesen. */
  var LAUFZEIT_TAGE = 365;
  var WAHLBAR = ['statistik', 'marketing', 'praeferenzen'];

  var kasten = null;
  var fenster = null;
  var gruppenliste = null;
  var vorherFokus = null;
  var offen = false;

  /* --- Ablage ------------------------------------------------------------ */

  function lesen() {
    try {
      var roh = window.localStorage.getItem(SCHLUESSEL);
      if (!roh) return null;
      var d = JSON.parse(roh);
      if (!d || d.fassung !== FASSUNG || !d.gruppen) return null;
      /* Ohne lesbaren Zeitpunkt laesst sich das Alter nicht pruefen. Dann
         gilt der Eintrag als nicht vorhanden -- lieber einmal zu oft
         gefragt als einmal zu lange gemessen. */
      var gesetzt = Date.parse(d.zeitpunkt);
      if (!isFinite(gesetzt)) return null;
      if (Date.now() - gesetzt > LAUFZEIT_TAGE * 24 * 60 * 60 * 1000) return null;
      return d;
    } catch (e) {
      return null;
    }
  }

  function schreiben(gruppen) {
    var eintrag = {
      fassung: FASSUNG,
      zeitpunkt: new Date().toISOString(),
      gruppen: {
        notwendig: true,
        statistik: !!gruppen.statistik,
        marketing: !!gruppen.marketing,
        praeferenzen: !!gruppen.praeferenzen
      }
    };
    try {
      window.localStorage.setItem(SCHLUESSEL, JSON.stringify(eintrag));
    } catch (e) {
      /* Kein Speicher: die Entscheidung gilt fuer diesen Seitenaufruf und
         wird beim naechsten erneut erfragt. */
    }
    return eintrag;
  }

  /* --- Weitergabe an das Ladensystem -------------------------------------
     Ohne diesen Schritt ist der Kasten Zierde. Die Schnittstelle wird bei
     Bedarf nachgeladen; ist sie schon da, wird der Rueckruf sofort bedient.
     sale_of_data haengt an der Gruppe Marketing: wer Werbung ablehnt, lehnt
     auch die Weitergabe zu Werbezwecken ab. */

  function weitergeben(gruppen) {
    var werte = {
      analytics: !!gruppen.statistik,
      marketing: !!gruppen.marketing,
      preferences: !!gruppen.praeferenzen,
      sale_of_data: !!gruppen.marketing
    };
    /* ⚠️ 15.09.2026: DIE SPERRE MUSS ZUERST ERFAHREN, WAS ERLAUBT IST.
       Die Einwilligungs-Schnittstelle des Ladens steuert nur, was der Laden
       selbst kennt. Clarity und Stape haengen daneben und wurden am
       15.09.2026 gemessen, wie sie VOR jeder Entscheidung hinausgingen.
       snippets/robby-cookie-sperre.liquid haelt sie zurueck; hier wird die
       Sperre geoeffnet, sobald jemand zustimmt. Ohne diese Zeile bleibt die
       Zustimmung ohne Wirkung -- und das waere schlimmer als die Ablehnung,
       weil der Kasten dann in beide Richtungen luegt. */
    try { if (typeof window.rbSperreFrei === 'function') window.rbSperreFrei(gruppen); } catch (e) {}

    var laden = window.Shopify && window.Shopify.loadFeatures;
    if (typeof laden !== 'function') return;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (fehler) {
        if (fehler) return;
        try {
          window.Shopify.customerPrivacy.setTrackingConsent(werte, function () {});
        } catch (e) {}
      });
    } catch (e) {}
  }

  /* --- Fokus im Fenster halten ------------------------------------------- */

  function fokusziele() {
    if (!fenster) return [];
    var alle = fenster.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(alle, function (el) {
      return !el.hasAttribute('hidden') && el.offsetParent !== null;
    });
  }

  function taste(ereignis) {
    if (!offen) return;
    if (ereignis.key === 'Escape') {
      ereignis.preventDefault();
      /* ⚠️ 16.09.2026: ESCAPE WIDERRUFT NICHTS MEHR.
         Gemessen am 16.09.2026: nach "Alle akzeptieren" stand alles auf
         true; der Kasten wurde ueber den Fusspunkt wieder geoeffnet,
         Escape gedrueckt, nichts gewaehlt -- danach dreimal false und die
         Schnittstelle viermal "no". Ein stillschweigender Widerruf ist
         genauso falsch wie eine stillschweigende Zustimmung: in beiden
         Faellen entscheidet der Kasten und nicht der Besucher.
         Liegt noch KEINE Entscheidung vor, bleibt alles wie bisher: Escape
         ist ein Abbruch und wirkt wie "Nur notwendige".
         Liegt bereits eine vor, wird NUR geschlossen und NICHTS
         geschrieben. Der Widerruf laeuft ueber die Knoepfe, nie ueber eine
         Taste, die man auch aus Versehen trifft. */
      if (lesen()) { schliessen(); return; }
      entscheiden({ statistik: false, marketing: false, praeferenzen: false });
      return;
    }
    if (ereignis.key !== 'Tab') return;
    /* ⚠️ 16.09.2026: DIE VORWAERTS-FALLE IST GEFALLEN -- ABSICHT, KEIN REST.
       Der Rahmen traegt pointer-events:none, die Seite dahinter war mit der
       Maus voll bedienbar, waehrend die Tastatur zu 14 von 14 im Kasten
       festhing. Das ist derselbe Kasten mit zwei verschiedenen Haerten, und
       die Tastatur war die haertere -- getroffen hat es genau die Besucher,
       die keine Maus benutzen. Aufgeloest wird es in Richtung der erklaerten
       Bauart: keine Vollbild-Sperre. Dazu gehoert das gestrichene
       aria-modal in snippets/robby-cookie.liquid; beides zusammen oder gar
       nicht, sonst sagt der Kasten wieder zweierlei.
       Wer vorwaerts hinaustabbt, ist im Laden. Der Kasten bleibt stehen, es
       wird nichts entschieden, und "Cookie-Einstellungen" im Fussbereich
       holt ihn jederzeit zurueck. */
    if (!ereignis.shiftKey) return;
    var ziele = fokusziele();
    if (!ziele.length) return;
    /* ⚠️ RUECKWAERTS BLEIBT DER UMLAUF -- UND ZWAR AUCH VOM FENSTER AUS.
       Gemessen am 16.09.2026: das erste Shift+Tab nach dem Oeffnen landete
       auf dem Sprunglink VOR dem Kasten. Die Umkehr griff nur, wenn der
       Fokus genau auf dem ersten Ziel stand; beim Oeffnen steht er aber auf
       dem Dialogfenster selbst (siehe oeffnen()). Deshalb steht das Fenster
       hier mit in der Bedingung. Rueckwaerts umlaufen heisst: der Weg zurueck
       fuehrt zu den Knoepfen, nicht an der Frage vorbei. */
    if (document.activeElement === ziele[0] || document.activeElement === fenster) {
      ereignis.preventDefault();
      ziele[ziele.length - 1].focus();
    }
  }

  /* --- Auf und zu -------------------------------------------------------- */

  function oeffnen(vorbelegung) {
    if (!kasten) return;
    vorherFokus = document.activeElement;
    setzeSchalter(vorbelegung || null);
    gruppenAuf(!!vorbelegung);
    kasten.hidden = false;
    offen = true;
    document.addEventListener('keydown', taste, true);
    lage();
    window.setTimeout(lagePlanen, 1500);
    window.setTimeout(lagePlanen, 4000);
    /* Der Fokus geht auf das Fenster selbst, nicht auf einen der Knoepfe:
       sonst liest die Sprachausgabe die Beschriftung vor, bevor sie die
       Frage vorgelesen hat. */
    window.requestAnimationFrame(function () {
      try { fenster.focus(); } catch (e) {}
    });
  }

  /* --- Ausweichen (12.10.2026) -------------------------------------------
     Der Kasten darf nie auf Kaufknopf, Express-Zahlung (PayPal-iframe) oder
     Kasse-Knopf liegen. Wuerde er das unten tun, rueckt er nach oben;
     verdeckt er auch oben etwas, bleibt er unten. */
  var ZIELE = '.shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, ' +
    '.additional-checkout-buttons, [name="checkout"], a[href^="/checkout"], ' +
    'product-form [type="submit"], .product-form__submit, [name="add"]';
  var lageGeplant = false;

  /* Zahlen und Kasse wiegen schwerer als ein Kaufknopf auf einer Karte. */
  var WICHTIG = '.shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, ' +
    '.additional-checkout-buttons, [name="checkout"], a[href^="/checkout"], .product-form__submit';

  function deckt(oben, unten, links, rechts) {
    var el = document.querySelectorAll(ZIELE);
    var summe = 0;
    for (var i = 0; i < el.length; i++) {
      var r = el[i].getBoundingClientRect();
      if (!r.height || !r.width) continue;
      if (r.bottom > oben && r.top < unten && r.right > links && r.left < rechts) summe += el[i].matches(WICHTIG) ? 10 : 1;
    }
    return summe;
  }

  function lage() {
    lageGeplant = false;
    if (!offen || !fenster) return;
    var f = fenster.getBoundingClientRect();
    var h = f.height + 16;
    var vh = window.innerHeight;
    var unten = deckt(vh - h, vh, f.left, f.right);
    var obenNoetig = unten > 0 && deckt(0, h, f.left, f.right) < unten;
    kasten.classList.toggle('rb-ck--oben', obenNoetig);
  }

  function lagePlanen() {
    if (lageGeplant || !offen) return;
    lageGeplant = true;
    window.requestAnimationFrame(lage);
  }

  function schliessen() {
    if (!kasten) return;
    kasten.hidden = true;
    offen = false;
    document.removeEventListener('keydown', taste, true);
    if (vorherFokus && typeof vorherFokus.focus === 'function' && document.contains(vorherFokus)) {
      try { vorherFokus.focus(); } catch (e) {}
    }
    vorherFokus = null;
  }

  function gruppenAuf(auf) {
    if (!gruppenliste) return;
    gruppenliste.hidden = !auf;
    var mehr = kasten.querySelector('[data-rb-ck="einstellungen"]');
    var speichern = kasten.querySelector('[data-rb-ck="auswahl"]');
    if (mehr) mehr.setAttribute('aria-expanded', auf ? 'true' : 'false');
    if (speichern) speichern.hidden = !auf;
    lagePlanen();
  }

  function setzeSchalter(gruppen) {
    WAHLBAR.forEach(function (name) {
      var feld = kasten.querySelector('[data-rb-ck-gruppe="' + name + '"]');
      if (!feld) return;
      /* Ohne vorliegende Entscheidung steht JEDER wahlbare Schalter auf aus.
         Nichts ist vorangekreuzt -- das ist der Kern des Opt-in. */
      feld.checked = gruppen ? !!gruppen[name] : false;
    });
  }

  function ausSchaltern() {
    var g = {};
    WAHLBAR.forEach(function (name) {
      var feld = kasten.querySelector('[data-rb-ck-gruppe="' + name + '"]');
      g[name] = !!(feld && feld.checked);
    });
    return g;
  }

  /* --- Die Entscheidung -------------------------------------------------- */

  function entscheiden(gruppen) {
    var eintrag = schreiben(gruppen);
    weitergeben(eintrag.gruppen);
    schliessen();
    try {
      document.dispatchEvent(new CustomEvent('rb:einwilligung', { detail: eintrag }));
    } catch (e) {}
  }

  /* --- Verdrahtung ------------------------------------------------------- */

  function start() {
    kasten = document.getElementById('rb-ck');
    if (!kasten) return;
    fenster = kasten.querySelector('.rb-ck__kasten');
    gruppenliste = kasten.querySelector('.rb-ck__gruppen');

    kasten.addEventListener('click', function (ereignis) {
      var knopf = ereignis.target.closest('[data-rb-ck]');
      if (!knopf) return;
      var was = knopf.getAttribute('data-rb-ck');
      if (was === 'alle') {
        entscheiden({ statistik: true, marketing: true, praeferenzen: true });
      } else if (was === 'notwendig') {
        entscheiden({ statistik: false, marketing: false, praeferenzen: false });
      } else if (was === 'auswahl') {
        entscheiden(ausSchaltern());
      } else if (was === 'einstellungen') {
        gruppenAuf(gruppenliste.hidden);
      }
    });

    /* Jeder Punkt mit diesem Merkmal ruft den Kasten erneut auf -- der
       Widerruf ist damit genauso leicht wie die Erteilung. Der Aufruf laeuft
       ueber das Dokument, damit auch ein spaeter eingefuegter Punkt wirkt. */
    document.addEventListener('click', function (ereignis) {
      var ruf = ereignis.target.closest('[data-rb-cookie-oeffnen]');
      if (!ruf) return;
      ereignis.preventDefault();
      oeffnen(gemerkt() ? gemerkt().gruppen : null);
    });

    window.addEventListener('scroll', lagePlanen, { passive: true });
    window.addEventListener('resize', lagePlanen);
    var vorhanden = lesen();
    if (vorhanden) {
      /* Die Entscheidung liegt vor: sie wird bei jedem Seitenaufruf erneut
         gemeldet, damit die Schnittstelle sie kennt, und der Kasten bleibt
         weg. */
      weitergeben(vorhanden.gruppen);
    } else {
      oeffnen(null);
    }
  }

  function gemerkt() {
    return lesen();
  }

  window.rbCookie = {
    oeffnen: function () { oeffnen(gemerkt() ? gemerkt().gruppen : null); },
    entscheidung: gemerkt,
    zuruecksetzen: function () {
      try { window.localStorage.removeItem(SCHLUESSEL); } catch (e) {}
      oeffnen(null);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
